.container {
    min-height: 100vh;
    background-color: #1C1D25;
    display: flex;
    flex-direction: column;
    justify-content: flex-start;
}

.contentContainer {
    height: 80vh;
    display: flex;
    align-items: center;
    margin-left: 50px;
}

.name {
    font-size: 4em;
    color: white;
    text-align: left;
    font-family: var(--font-display);
    font-weight: bolder;
    margin-top: 1.33em;
    margin-bottom: 10px;
}

.description {
    text-align: left;
    color: white;
    font-size: 1.2em;
    font-style: italic;
}

.textBlock {
    z-index: 2;
}

.nameContainer {
    width: 85vw;
    display: flex;
    align-items: center;
    flex-direction: column;
}

.buttonContainer {
    margin-top: 20px;
    display: flex;
    align-items: center;
    align-self: flex-start;
}

/* the button arrow sticks out to the right of the button, leave room for it */
.buttonContainer .cvLink {
    margin-left: 72px;
    color: #B0B2C3;
}

.buttonContainer .cvLink:hover {
    color: white;
}

.logoContainer {
    top: 25%;
    left: 42%;
    object-fit: cover;
    position: absolute;
}

.iconContainer {
    display: flex;
    flex-direction: column;
    position: absolute;
    right: 15px;
    gap: 35px;
    z-index: 2;
    transition: 0.4s;
}

.hiddenElement {
    display: flex;
    flex-direction: column;
    position: absolute;
    right: 15px;
    gap: 35px;
    z-index: 2;
    opacity: 0;
    transition: 0.4s;
}

.hiddenHeader {
    opacity: 0;
    transition: opacity 0.4s;
}

.headerContainer {
    opacity: 1;
    transition: opacity 0.4s;
}

.icon {
    cursor: pointer;
    transition: 0.4s;
}

.icon:hover path {
    fill: white;
    transition: 0.4s;
}

.worksContainer {
    width: 100%;
    display: flex;
    justify-content: center;
    position: absolute;
    bottom: 0;
    color: white;
}

.worksContainer a {
    color: inherit;
    text-decoration: none;
}

.works {
    cursor: pointer;
}

@media (max-height: 900px) {
    .logoContainer {
        top: 20%;
    }
}


@media (max-width: 768px) {
    /* svh is the visible height, without the part under the browser bars */
    .container {
        position: relative;
        overflow: hidden;
        min-height: 100svh;
    }

    /* one centered column: logo, name, buttons, and the social icons at the bottom */
    .contentContainer {
        flex: 1;
        flex-direction: column;
        height: auto;
        margin-left: 0;
        padding: 0 24px;
    }

    .nameContainer {
        flex: 1;
        justify-content: center;
        width: 100%;
    }

    .textBlock {
        width: 100%;
        text-align: center;
    }

    /* the logo goes above the name, the name covers its lower tip */
    .logoContainer {
        position: static;
        order: -1;
        margin-bottom: -52px;
    }

    .logoContainer svg {
        display: block;
        width: min(62vw, 280px);
        height: auto;
    }

    .name {
        font-size: 2.4em;
        margin-top: 0;
        text-align: center;
    }

    .description {
        display: block;
        font-size: 1.05em;
        text-align: center;
    }

    .buttonContainer {
        flex-direction: column;
        align-items: center;
        align-self: center;
        gap: 10px;
        width: 100%;
        max-width: 360px;
        margin: 28px auto 0;
    }

    .buttonContainer .cvLink {
        margin-left: 0;
        padding: 12px 0;
    }

    .aboutButton {
        width: 100%;
    }

    .aboutButton > div {
        padding: 14px 28px;
        text-align: center;
    }

    /* the arrow moves inside of the wide button and stays there on hover */
    .buttonContainer .aboutButton svg,
    .buttonContainer .aboutButton div:hover ~ svg {
        top: 7px;
        right: 18px;
        transform: none;
    }

    /* the icons react to the cursor, there is none on a phone */
    .decorIcons {
        display: none;
    }

    .iconContainer, .hiddenElement {
        position: static;
        flex-direction: row;
        justify-content: center;
        gap: 12px;
        padding: 16px 0 4px;
    }

    .worksContainer {
        position: static;
    }

    /* 44px tap area around a 32px icon */
    .socialLink {
        display: flex;
        align-items: center;
        justify-content: center;
        width: 44px;
        height: 44px;
    }

    .icon {
        width: 32px;
        height: 32px;
    }
}
